import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "modal-overlay"
};
const _hoisted_2 = { class: "modal-content" };
const _hoisted_3 = { class: "order-info" };
const _hoisted_4 = { class: "order-reference" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'NewOrderModal',
    props: {
        visible: { type: Boolean },
        transactionReference: {}
    },
    emits: ["close"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const handleClose = () => {
            emit("close");
        };
        return (_ctx, _cache) => {
            return (__props.visible)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", {
                        class: "modal-container",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["stop", "prevent"]))
                    }, [
                        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "modal-header" }, [
                            _createElementVNode("div", { class: "modal-icon" }, [
                                _createElementVNode("i", { class: "fas fa-bell" })
                            ]),
                            _createElementVNode("h2", { class: "modal-title" }, "Nouvelle commande")
                        ], -1)),
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("p", _hoisted_4, [
                                    _cache[1] || (_cache[1] = _createTextVNode(" Commande #", -1)),
                                    _createElementVNode("strong", null, _toDisplayString(__props.transactionReference), 1)
                                ])
                            ])
                        ]),
                        _createElementVNode("div", { class: "modal-footer" }, [
                            _createElementVNode("button", {
                                class: "close-btn",
                                onClick: handleClose
                            }, [...(_cache[2] || (_cache[2] = [
                                    _createElementVNode("i", { class: "fas fa-check" }, null, -1),
                                    _createTextVNode(" J'ai compris ", -1)
                                ]))])
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
